import {date, weekToDateRange} from '@eitje/utils'

const SCOPE_RETENTION_WEEKS = 3

export const buildScopePruningPlan = (scopes, anchorScopes) => {
	const anchorScopeIds = new Set(anchorScopes.map(scope => scope.id))

	return anchorScopes
		.map(anchorScope => {
			if (!anchorScope.prunable) return null
			const expiredScopeIds = getExpiredScopeIds(scopes, anchorScope, anchorScopeIds)
			return expiredScopeIds.length > 0 ? {kind: anchorScope.kind, expiredScopeIds} : null
		})
		.filter(Boolean)
}

export const pruneRecordScopes = (state, pruningPlan) => {
	let nextState = state
	pruningPlan.forEach(({kind, expiredScopeIds}) => {
		nextState = removeScopes(nextState, kind, expiredScopeIds)
	})

	return nextState
}

const getExpiredScopeIds = (scopes, anchorScope, anchorScopeIds) => {
	const {start: anchorStart, end: anchorEnd} = getScopeDateRange(anchorScope)
	if (!anchorStart || !anchorEnd) return []

	const retainedStart = date(anchorStart).subtract(SCOPE_RETENTION_WEEKS, 'weeks')
	const retainedEnd = date(anchorEnd).add(SCOPE_RETENTION_WEEKS, 'weeks')

	return Object.values(scopes)
		.filter(scope => scope.prunable && scope.kind === anchorScope.kind && !anchorScopeIds.has(scope.id))
		.filter(scope => {
			const {start: scopeStart, end: scopeEnd} = getScopeDateRange(scope)
			if (!scopeStart || !scopeEnd) return false
			return date(scopeEnd).isBefore(retainedStart, 'day') || date(scopeStart).isAfter(retainedEnd, 'day')
		})
		.map(scope => scope.id)
}

const getScopeDateRange = scope => {
	const {start_date: start, end_date: end, weeknumber = [], year = []} = scope.filters
	if (start && end) return {start, end}

	const week = weeknumber[0]
	const weekYear = year[0]
	return week && weekYear ? weekToDateRange({week, year: weekYear}) : {}
}

const removeScopes = (state, kind, expiredScopeIds) => {
	const expiredScopeIdSet = new Set(expiredScopeIds)
	const scopes = {...state.scopes}
	expiredScopeIds.forEach(scopeId => delete scopes[scopeId])

	const records = (state[kind] || [])
		.map(record => {
			if (!record.scopeIds?.some(scopeId => expiredScopeIdSet.has(scopeId))) return record
			const scopeIds = record.scopeIds.filter(scopeId => !expiredScopeIdSet.has(scopeId))
			return scopeIds.length > 0 ? {...record, scopeIds} : null
		})
		.filter(Boolean)

	return {...state, [kind]: records, scopes}
}
